import React from 'react';
import GameTypeFilter from './GameTypeFilter';
import { AllGameProps } from '../types';

function AllGame(props: AllGameProps) {
  const { gameList, setGameModalVisible, menuWidth } = props;

  return (
    <GameTypeFilter
      gameList={gameList}
      setGameModalVisible={setGameModalVisible}
      menuWidth={menuWidth}
    />
  );
}

export default AllGame;
